/**
 * Manager Dashboard Help Content
 *
 * Feature: 177 - Dashboard Polish & Collection Column Coverage (US1)
 * Page: /dashboard (Manager role variant)
 * Constitution: v1.22.0 — Principle XXXVII (Code Header Standards)
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const managerDashboardHelp: PageHelpContent = {
  pageTitle: 'Manager Dashboard',
  purpose:
    'Your portfolio view of the Fabric Control Plane: business KPIs, per-client breakdown, and SLA / backup coverage across all capacities.',
  sections: [
    {
      title: 'What this view shows',
      paragraphs: [
        'The Manager dashboard summarizes the estate at a business level rather than an operational one. It leads with portfolio KPI panels (capacity fleet, storage, governance, entity growth), followed by the key business metrics and a per-client breakdown.',
      ],
      concepts: [
        { term: 'Portfolio KPIs', definition: 'Capacity fleet utilization, total managed storage, governance posture, and entity-growth sparklines for workspaces, lakehouses, warehouses, and container apps.' },
        { term: 'Business KPIs', definition: 'Total Workspaces, Data Volume (Azure + OneLake + warehouse), Backup Coverage, and SLA Compliance — the headline health of the managed estate.' },
        { term: 'Client Breakdown', definition: 'Per-client SLA tier, capacity count, workspace count, and active status.' },
        { term: 'SLA & Backup Coverage', definition: 'Backup Coverage = share of critical data with a recent successful backup; SLA Compliance = current-month compliance against contracted targets.' },
      ],
    },
    {
      title: 'Coming soon',
      paragraphs: [
        'The Cost Estimation panel is a placeholder today. Real financial/cost analytics (per-client cost attribution, actual Azure spend) are delivered by the dedicated cost-analytics work, not this dashboard.',
      ],
    },
    {
      title: 'Data Refresh',
      paragraphs: [
        'KPIs and metrics refresh automatically (polling, ~30–60s). Figures reflect the latest completed collection run.',
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Clients', href: '/admin/clients' },
        { label: 'Capacity Metrics', href: '/capacity-metrics' },
        { label: 'Backup', href: '/backup' },
        { label: 'Workspaces', href: '/workspaces' },
      ],
    },
  ],
};

export default managerDashboardHelp;
